export default "__VITE_ASSET__88f0ea98__"